export const figure16 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '800px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#5b9bd5'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    exporting: {
      enabled: false
    },

xAxis: {
    categories: [
	 "Malawi 2020",
	 "Équateur 2014",
	 "Ouganda 2020",
	 "Pérou 2019",
	 "Niger 2014",
	 "Afrique du Sud 2015",
	 "Inde 2012",
	 "Burkina Faso 2019",
	 "Pakistan 2014",
	 "Népal 2011",
	 "Rwanda 2014",
	 "Éthiopie 2019",
	 "Iraq 2012",
	 "Cameroun 2014",
	 "Guatemala 2014",
	 "Kirghizistan 2013",
	 "Ghana 2017",
	 "Bangladesh 2010",
	 "République-Unie de Tanzanie 2015",
	 "Togo 2019",
	 "Viet Nam 2010",
	 "Guinée-Bissau 2019",
	 "Sierra Leone 2011",
	 "Nigéria 2019",
	 "Mali 2017",
	 "Mongolie 2019",
	 "Mexique 2014",
	 "Nicaragua 2014",
	 "Bénin 2019",
	 "Arménie 2013",
	 "Sénégal 2019",
	 "Géorgie 2020",
    ],
    title: {
        text: null
    }
},
yAxis: {
    min: 0.00,
    max: .900,
    tickInterval: 0.100,
    title: {
        text: null,
    },
    labels: {
        overflow: 'justify'
    }
},
plotOptions: {
    bar: {
        dataLabels: {
            enabled: true
        }
    }
},
legend: {
    enabled: false,
},
series: [{
    name: '',
    data: [
	   0.81, 
	   0.64, 
	   0.60, 
	   0.57, 
	   0.53, 
	   0.53, 
	   0.51, 
	   0.47, 
	   0.46, 
	   0.42, 
	   0.42, 
	   0.41, 
	   0.41, 
	   0.40, 
	   0.38, 
	   0.38, 
	   0.37, 
	   0.37, 
	   0.37, 
	   0.36, 
	   0.34, 
	   0.33, 
	   0.32, 
	   0.30, 
	   0.28, 
	   0.25, 
	   0.25, 
	   0.23, 
	   0.19, 
	   0.14, 
	   0.13, 
	   0.11,
     ] ,
}]
}